//컬럼 정의
export const _columns = [
  {
    field: "psDate",
    headerName: "날짜",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      return value
        ? `${value.substring(0, 4)}.${value.substring(4, 6)}.${value.substring(
            6
          )}`
        : "";
    },
  },
  {
    field: "method",
    headerName: "사용/공급",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      let name = "";
      switch (value) {
        case "cons":
          name = "사용";
          break;
        case "prod":
          name = "공급";
          break;
        default:
          name = value;
      }
      return name;
    },
  },
  {
    field: "engId",
    headerName: "에너지종류",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      let engName = "";
      switch (value) {
        case "AIR":
          engName = "압축공기";
          break;
        case "STEAM":
          engName = "스팀";
          break;
        case "COOLWATER":
          engName = "냉수";
          break;
        case "EPWR":
          engName = "전기";  
          break;
        default:
          engName = value;
      }
      return engName;
    },
  },
  
  {
    field: "engUnit",
    headerName: "단위",
    width: 130,
  },
  {
    field: "complexInloName",
    headerName: "산업단지명",
    width: 130,
  },
  {
    field: "companyInloName",
    headerName: "회사명",
    width: 130,
    // valueGetter: getFullName,
  }, 
  {
    field: "plantInloName",
    headerName: "사업장명",
    width: 130,
  },
  {
    field: "sumAmt",
    headerName: "합계",
    width: 120,
    valueFormatter: (params) => {
      // return new Intl.NumberFormat("ko-KR").format(params.value);
      return new Intl.NumberFormat("ko-KR").format(Math.round(params.value));
    },
  },
];


export const managerColumns = (columns) => {
  return columns.map((column) => ({
    ...column,
    headerClassName: "DataGridHeader",
  }));
};

export const columns2_3 = managerColumns(_columns);

